import { AppointmentCustomer } from './../../../models/AppointmentCustomer';
import { ProductService } from './../../../services/product.service';
import { UtilsService } from './../../../services/utils.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/services/customer.service';
import { UserService } from '../../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { DynamicForm } from '../../../models/DynamicForm';
import { SchedulerEvent } from '../../../models/SchedulerEvent';
import { FormControlService } from '../../../services/form-control.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ScheduleService } from '../../../services/schedule.service';
import { User, UserType } from '../../../models/User';
import { Customer } from '../../../models/Customer';
import { Setting } from '../../../models/Setting';
import { SettingService } from '../../../services/setting.service';
import { Invoice } from 'src/app/models/Invoice';
import { InvoiceService } from 'src/app/services/invoice.service';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormsModule,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Button } from '../../../models/Button';
import { ProductPackage } from 'src/app/models/ProductPackage';
import { PrivilegeService } from 'src/app/services/privilege.service';
import { Role } from 'src/app/models/Role';
import { CustomerRelation } from 'src/app/models/CustomerRelation';
import { AuthService } from 'src/app/services/auth.service';
import { OrganizationUnit } from '../../../models/OrganizationUnit';
import { OrganizationUnitService } from '../../../services/organization-unit.service';
import { VisitCertificatePdfService } from '../../../services/visit-certificate-pdf.service';
import {
  PRINT_LANGUAGES,
  isPrintLanguage
} from '../../../services/print-translation.service';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form/dynamic-form.component';
import { AsyncPipe, KeyValuePipe } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { CalendarInputComponent } from '../../shared/calendar-input/calendar-input.component';
import { InputMask } from 'primeng/inputmask';
import { CustomerSelectorComponent } from '../../shared/customer-selector/customer-selector.component';
import { ScBasicInfoComponent } from '../../customer/customer/sc-basic-info/sc-basic-info.component';
import { Select } from 'primeng/select';
import { MultiSelect } from 'primeng/multiselect';
import { RadioButton } from 'primeng/radiobutton';
import { UserSelectorComponent } from '../../shared/user-selector/user-selector.component';
import { Popover } from 'primeng/popover';

import { AppDatePipe } from '../../../pipes/app-date.pipe';
@Component({
  selector: 'app-scheduler-event',
  templateUrl: './schedulerEvent.component.html',
  styleUrls: ['./schedulerEvent.component.scss'],

  imports: [
    DynamicFormComponent,
    AsyncPipe,
    ReactiveFormsModule,
    FormsModule,
    ButtonDirective,
    TranslatePipe,
    CalendarInputComponent,
    InputMask,
    CustomerSelectorComponent,
    ScBasicInfoComponent,
    Select,
    MultiSelect,
    RadioButton,
    UserSelectorComponent,
    Popover,
    AppDatePipe,
    KeyValuePipe
  ]
})
export class SchedulerEventComponent implements OnInit {
  public selectedDate: Date;
  private formName = 'event';
  public selectedUser: User | null = null;
  public selectedCustomer: Customer | null = null;
  public selectedDonor: Customer | null = null;
  public eventData: any = null;
  private eventOriginal: any = null;
  private customerInvoice: Invoice | null = null;
  private saveMsg: string | undefined = undefined;
  public formDisabled = false;
  public editableEvent = true;
  public eventForm$: Observable<DynamicForm> | null = null;
  public selectedEventType: Setting | undefined = undefined;
  public eventTypes: Array<Setting> | null = null;
  public eventInfo: any;
  public saveAndRouteButtonTitle: string | null = null;
  public saveDisabled = false;

  public eventForm: FormGroup;
  public saveButton: Button;
  public saveAndRouteButton: Button;
  public goToFormsButton: Button;
  public healthRecordButton: Button;
  public eraButton: Button;
  public cancelButton: Button;
  public createCustomerButton: Button;
  public userTypeCustomer: UserType = UserType.customer;
  public userTypeStaff: UserType = UserType.staff;
  public userTypeCustomerDonor = UserType.customerDonor;
  public net: Boolean = false;
  public partner: Customer | null = null;
  public appointmentCustomer: AppointmentCustomer | null = null;
  public inlineScCustomer: Customer | null = null;
  public showInlineScForm = false;
  public eraVisitEntriesEnabled = false;

  public yesNoSettings: Array<Setting> = [];
  public packageUserTypes: Array<Setting> = [];
  public rooms: Array<Setting> = [];
  public eventStatusSettings: Array<Setting> = [];
  public eventRoles: Array<Role> = [];
  public eventPackages: Array<ProductPackage> = [];
  public triggerDurationOptions: Array<Setting> = [];
  public selectedTriggerDuration: string | null = null;
  public triggerTimeBasedOnOpu: Date | null = null;
  /** Käyntitodistus printout (AL-2893). */
  public printing = false;
  public readonly printLanguages = PRINT_LANGUAGES;
  /** Marked in the language menu; known once the unit has loaded. */
  public defaultPrintLanguage: string | null = null;
  private printOrganizationUnit: Promise<OrganizationUnit | null> | null = null;

  private toFormData(schedulerEvent: SchedulerEvent): any {
    const eventData: any = {};
    if (schedulerEvent.start) {
      const start = new Date(schedulerEvent.start);
      eventData.start =
        String(start.getHours()).padStart(2, '0') +
        ':' +
        String(start.getMinutes()).padStart(2, '0');
    }
    if (schedulerEvent.end) {
      const end = new Date(schedulerEvent.end);
      eventData.end =
        String(end.getHours()).padStart(2, '0') +
        ':' +
        String(end.getMinutes()).padStart(2, '0');
    }
    eventData.id = schedulerEvent.id;
    eventData.eventType = schedulerEvent.eventType;
    eventData.eventDate = schedulerEvent.eventDate;
    eventData.room = schedulerEvent.room;
    eventData.description = schedulerEvent.description;
    eventData.info = schedulerEvent.info;
    eventData.net = schedulerEvent.net;
    eventData.status = schedulerEvent.status;
    eventData.userId = schedulerEvent.userId;
    eventData.roleId = schedulerEvent.roleId;
    eventData.customerId = schedulerEvent.customerId;
    eventData.donorId = schedulerEvent.donorId;
    eventData.user = schedulerEvent.user;
    eventData.customer = schedulerEvent.customer;
    eventData.productId = schedulerEvent.productId;
    eventData.productPackageId = schedulerEvent.productPackageId;
    eventData.invoiceId = schedulerEvent.invoiceId;
    eventData.userGroup = schedulerEvent.userGroup;
    if (schedulerEvent.userGroups && schedulerEvent.userGroups.length) {
      eventData.userGroups = schedulerEvent.userGroups;
    } else {
      eventData.userGroups = schedulerEvent.userGroup
        ? [schedulerEvent.userGroup]
        : [];
    }
    eventData.appointmentDescription = schedulerEvent.appointmentDescription;
    eventData.productPackageUserType = schedulerEvent.productPackageUserType;
    eventData.appointmentCode = schedulerEvent.appointmentCode;
    eventData.triggerDuration = schedulerEvent.triggerDuration;
    eventData.appointmentCustomerId = schedulerEvent.appointmentCustomerId;
    eventData.appointmentCustomer = schedulerEvent.appointmentCustomer;
    eventData.organizationForm = schedulerEvent.organizationForm;
    return eventData;
  }
  constructor(
    private formService: FormControlService,
    private messageService: MessageService,
    private schedulerService: ScheduleService,
    private settingService: SettingService,
    private userService: UserService,
    private customerService: CustomerService,
    private translateService: TranslateService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private utilsService: UtilsService,
    private invoiceService: InvoiceService,
    private productService: ProductService,
    private router: Router,
    private formBuilder: FormBuilder,
    private privilegeService: PrivilegeService,
    private authService: AuthService,
    private organizationUnitService: OrganizationUnitService,
    private visitCertificatePdfService: VisitCertificatePdfService
  ) {
    this.selectedDate = new Date();

    this.saveButton = new Button();
    this.saveButton.title = this.translateService.instant('common.save');
    this.saveButton.styleClass = 'p-button-primary';
    this.saveButton.id = 'save';

    this.saveAndRouteButton = new Button();
    this.saveAndRouteButton.styleClass = 'p-button-success';
    this.saveAndRouteButton.id = 'saveandroute';
    this.saveAndRouteButton.routeTo = 'customer';
    this.saveAndRouteButton.title = this.translateService.instant(
      'event.save-and-route-to-customer'
    );

    this.healthRecordButton = new Button();
    this.healthRecordButton.styleClass = 'p-button-success';
    this.healthRecordButton.id = 'healthrecord';
    this.healthRecordButton.routeTo = 'healthrecord';
    this.healthRecordButton.title = this.translateService.instant(
      'event.save-and-go-to-health-record'
    );

    this.eraButton = new Button();
    this.eraButton.styleClass = 'p-button-success';
    this.eraButton.id = 'era';
    this.eraButton.routeTo = 'era';
    this.eraButton.title = this.translateService.instant(
      'event.save-and-open-era'
    );

    this.cancelButton = new Button();
    this.cancelButton.title = this.translateService.instant('common.cancel');
    this.cancelButton.styleClass = 'p-button-secondary';
    this.cancelButton.id = 'cancel';

    this.createCustomerButton = new Button();
    this.createCustomerButton.title = this.translateService.instant(
      'event.create-appointment-customer'
    );
    this.createCustomerButton.styleClass = '';
    this.createCustomerButton.id = 'createcustomer';

    this.goToFormsButton = new Button();
    this.goToFormsButton.styleClass = '';
    this.goToFormsButton.id = 'gotoforms';
    this.goToFormsButton.routeTo = 'forms';
    this.goToFormsButton.title = this.translateService.instant(
      'event.save-and-route-to-forms'
    );

    this.eventForm = this.formBuilder.group({
      id: [''],
      invoiceId: [''],
      eventDate: [''],
      start: ['', Validators.required],
      end: ['', Validators.required],
      productPackageUserType: [''],
      productPackageId: [''],
      room: [''],
      info: [''],
      net: [''],
      status: [''],
      user: [''],
      customer: [''],
      userGroups: [[]],
      appointmentDescription: ['']
    });

    this.eventForm.get('start')!.valueChanges.subscribe(() => {
      this.recomputeTriggerTime();
    });
    this.eventForm.get('productPackageId')!.valueChanges.subscribe(() => {
      this.recomputeTriggerTime();
    });
  }

  private getSettings(): void {
    this.settingService.getSettingByName('YES_NO').then((settings) => {
      this.yesNoSettings = settings;
    });
    this.settingService
      .getSettingByName('PACKAGE_USER_TYPE')
      .then((settings) => {
        this.packageUserTypes = settings;
      });
    this.settingService.getSettingByName('ROOM').then((settings) => {
      this.rooms = settings;
    });
    this.settingService.getSettingByName('EVENT_STATUS').then((settings) => {
      this.eventStatusSettings = settings;
    });

    this.productService.getPackagesByType('schedule').then((packages) => {
      this.eventPackages = packages;
    });
    this.settingService
      .getSettingByName('TRIGGER_DURATION')
      .then((settings) => {
        this.triggerDurationOptions = settings;
      });
    this.privilegeService.getEventRoles().then((roles) => {
      this.eventRoles = roles;
      if (this.eventRoles && this.eventRoles[0]) {
        this.eventRoles.map((r) => {
          r.translation = this.translateService.instant(
            `event.groups.${r.name}`
          );
        });
      }
    });
  }

  private checkAppointmentForms(customerId: string): void {
    if (customerId) {
      this.customerService
        .doesAppointmentFormDataExist(customerId)
        .then((exists) => {
          if (exists) {
            this.goToFormsButton.styleClass = 'p-button-success p-button';
          } else {
            this.goToFormsButton.styleClass = 'p-button';
          }
        });
    } else {
      this.goToFormsButton.styleClass = 'p-button';
    }
  }

  async ngOnInit(): Promise<void> {
    this.getSettings();
    if (this.dynamicDialogConfig.data.eventInfo) {
      this.eventInfo = this.dynamicDialogConfig.data.eventInfo;
    }

    // Pre-initialize eventData and selectedEventType before the async settings
    // load to prevent the event window from showing blank while awaiting the
    // EVENT_TYPE settings. Both template sections are hidden when eventData is
    // null or selectedEventType is undefined, which produces a blank dialog.
    // Only pre-initialize for new events (no id) to avoid showing stale data
    // for existing events that are fetched from the backend.
    if (
      this.dynamicDialogConfig.data.eventData &&
      !this.dynamicDialogConfig.data.eventData.id
    ) {
      this.eventData = this.toFormData(this.dynamicDialogConfig.data.eventData);
      // Pre-select the event's own type until the real settings load, so the
      // wrong section doesn't flash — e.g. opening a new todo must not briefly
      // render the appointment form while EVENT_TYPE settings are still loading.
      this.selectedEventType = {
        code: this.eventData.eventType || 'appointment'
      } as any;
    }

    this.eventTypes = await this.settingService.getSettingByName('EVENT_TYPE');
    this.saveMsg = this.translateService.instant(
      'event.messages.event-save-success'
    );
    this.saveAndRouteButtonTitle = this.translateService.instant(
      'event.save-and-route-to-customer'
    );

    const userProfile = this.authService.getUserProfile();
    if (userProfile?.activeOrganizationUnit) {
      this.eraVisitEntriesEnabled =
        !!userProfile.activeOrganizationUnit.eraVisitEntries;
      if (userProfile.activeOrganizationUnit.triggerDuration) {
        this.selectedTriggerDuration =
          userProfile.activeOrganizationUnit.triggerDuration;
      }
    }

    if (this.dynamicDialogConfig.data.eventData) {
      // if event data contains id fetch event info from backend
      if (this.dynamicDialogConfig.data.eventData.id) {
        this.schedulerService
          .getSchedulerEvent(this.dynamicDialogConfig.data.eventData.id)
          .subscribe((result) => {
            this.eventData = this.toFormData(result);
            if (this.eventData.net) {
              this.net = true;
            }
            if (this.eventData.customer) {
              this.selectedCustomer = this.eventData.customer;
              if (this.eventData.customer.relations) {
                const p = this.eventData.customer.relations.find(
                  (r: CustomerRelation) =>
                    r.relation === 'partner' && r.status === 1
                );
                if (p) {
                  this.partner = p;
                }
              }
            }
            if (this.eventData.donor) {
              this.selectedDonor = this.eventData.donor;
            }
            if (this.eventData.user) {
              this.selectedUser = this.eventData.user;
            }
            if (this.eventData.eventType) {
              this.selectedEventType = this.eventTypes!.find(
                (item) => item.code === this.eventData.eventType
              );
            }
            if (this.eventData.eventDate) {
              this.selectedDate = this.eventData.eventDate;
            }

            this.formDisabled = !result.editable;
            this.editableEvent = result.editable;

            if (this.formDisabled) {
              this.eventForm.disable();
            }

            this.setEventData(true);
            this.buildInlineScCustomer();
            this.eventOriginal = { ...this.eventData };
            if (this.eventData.triggerDuration) {
              this.selectedTriggerDuration = this.eventData.triggerDuration;
              this.recomputeTriggerTime();
            }
          });
      } else {
        this.eventData = this.toFormData(
          this.dynamicDialogConfig.data.eventData
        );
        this.selectedDate = this.eventData.eventDate;
        if (this.eventData.triggerDuration) {
          this.selectedTriggerDuration = this.eventData.triggerDuration;
        }
        if (this.eventData.eventType) {
          this.selectedEventType = this.eventTypes!.find(
            (item) => item.code === this.eventData.eventType
          );
        } else {
          this.selectedEventType = this.eventTypes!.find(
            (item) => item.code === 'appointment'
          );
        }

        await this.setEventData();
        this.buildInlineScCustomer();
        this.eventOriginal = { ...this.eventData };
      }
    }
  }

  async setEventData(dontUseEventInfo?: boolean): Promise<void> {
    if (this.eventInfo && !dontUseEventInfo) {
      this.eventData = this.toFormData(this.eventInfo.userEvent);
    } else {
      this.loadForm();
    }

    if (this.eventData.customerId) {
      this.checkAppointmentForms(this.eventData.customerId);
      const customer = await this.customerService.getCustomer(
        this.eventData.customerId
      );
      if (customer) {
        this.eventData.customer = customer;
        this.selectedCustomer = customer;
      }
    }

    if (this.eventData.donorId) {
      this.checkAppointmentForms(this.eventData.donorId);
      const donor = await this.customerService.getDonor(this.eventData.donorId);
      if (donor) {
        this.eventData.donor = donor;
      }
    }

    if (this.eventData.userId) {
      this.userService.getUser(this.eventData.userId).subscribe(
        (user) => {
          this.eventData.user = user;
          this.selectedUser = user;

          this.loadForm();
        },
        (error) => {
          this.loadForm();
        }
      );
    } else {
      this.loadForm();
    }
  }

  loadForm(): void {
    switch (this.selectedEventType!.code) {
      case 'todo':
        this.formName = 'event-todo';
        this.formService
          .loadForm(this.formName, this.eventData)
          .then((form) => {
            this.eventForm$ = form;
          });
        break;
      case 'appointment':
        this.eventForm.patchValue(this.eventData);
        this.formName = 'event';
        break;
      case 'week_plan':
        this.formName = 'event-week-plan';
        this.formService
          .loadForm(this.formName, this.eventData)
          .then((form) => {
            this.eventForm$ = form;
          });
        break;
    }
  }

  async saveEvent(eventData: any, routeTo?: string): Promise<void> {
    // let addToPackage = false;
    if (this.selectedCustomer && this.selectedCustomer.id) {
      /*
      if (!this.eventOriginal.id) {
        addToPackage = true;
      } else {
        if (this.eventOriginal.customerId !== this.selectedCustomer.id) {
          addToPackage = true;
        }
      } */
    }
    try {
      // Create start and end times and validate event data. If data is invalid throws an error
      // Event date, start and end times are not mandatory in todo -events.
      if (eventData.start && eventData.end) {
        let eventDate = eventData.eventDate;
        if (typeof eventDate === 'string') {
          eventDate = new Date(eventDate);
        }
        eventData.start = this.schedulerService.creatDateTime(
          eventDate,
          eventData.start
        );
        eventData.end = this.schedulerService.creatDateTime(
          eventDate,
          eventData.end
        );
      } else {
        // Todos may be created without a time. Send empty start/end as null so
        // the (DATE) columns aren't given an empty string, which the DB rejects.
        eventData.start = null;
        eventData.end = null;
      }
      const schedulerEventData: SchedulerEvent =
        this.schedulerService.toSchedulerEventData(eventData);

      // make sure that user and customer fields have the correct values
      // Send null (not undefined) when no staff is selected. undefined keys are
      // dropped by JSON.stringify, so the backend's Sequelize update would leave
      // the existing user_id untouched and re-assign the previously selected
      // staff member on edit. null is serialized and clears the column, matching
      // how customerId/donorId below are handled.
      schedulerEventData.userId = this.selectedUser?.id || null;
      schedulerEventData.customerId = this.selectedCustomer?.id || null;
      schedulerEventData.donorId = this.selectedDonor?.id || null;
      schedulerEventData.eventType = this.selectedEventType!.code;
      schedulerEventData.invoiceId = this.eventData.invoiceId;
      schedulerEventData.triggerDuration = this.selectedTriggerDuration;

      // A todo must be assigned to a person or to a group. If a group is
      // selected the staff field is optional; otherwise staff is mandatory.
      if (
        schedulerEventData.eventType === 'todo' &&
        !schedulerEventData.roleId &&
        !schedulerEventData.userId
      ) {
        this.messageService.clear();
        this.messageService.add({
          severity: 'warn',
          summary: '',
          detail: this.translateService.instant(
            'event.messages.todo-staff-or-group-required'
          )
        });
        return;
      }

      // if (this.selectedUser) {
      //   schedulerEventData.user = this.selectedUser;
      // } else {
      //   schedulerEventData.user = {} as User;
      // }

      this.schedulerService.validateSchedulerEvent(schedulerEventData);

      // Save event and close the dialog if everything is ok.
      const savedEvent =
        await this.schedulerService.saveSchedulerEvent(schedulerEventData);

      if (savedEvent) {
        // Let event-list views (e.g. the home page) refresh immediately.
        this.schedulerService.notifyEventsChanged();
        this.messageService.clear();
        if (routeTo === 'customer' && this.selectedCustomer) {
          this.utilsService.addMessage(this.saveMsg || '');
          if (this.selectedCustomer.customerType === 'd') {
            this.router.navigate(['donor/basic', this.selectedCustomer.id]);
          } else {
            this.router.navigate(['customer/basic', this.selectedCustomer.id]);
          }
          this.dynamicDialogRef.close({
            type: 'success'
          });
        } else if (routeTo === 'forms' && this.selectedCustomer) {
          this.utilsService.addMessage(this.saveMsg || '');
          if (this.selectedCustomer.customerType === 'd') {
            this.router.navigate([
              'donor/basic',
              this.selectedCustomer.id,
              'organization-forms'
            ]);
          } else {
            this.router.navigate([
              'customer/basic',
              this.selectedCustomer.id,
              'organization-forms'
            ]);
          }
          this.dynamicDialogRef.close({
            type: 'success'
          });
        } else if (routeTo === 'healthrecord' && this.selectedCustomer) {
          await this.customerService.setSelectedCustomer(this.selectedCustomer);
          if (this.selectedCustomer.customerType === 'd') {
            this.router.navigate(['donor/healthrecord/list']);
          } else {
            this.router.navigate(['customer/healthrecord/list']);
          }
          this.dynamicDialogRef.close({
            type: 'success'
          });
        } else if (routeTo === 'era' && this.selectedCustomer) {
          // TODO: open ERA
        } else {
          this.messageService.add({
            severity: 'success',
            summary: '',
            detail: this.saveMsg
          });
          this.dynamicDialogRef.close({
            type: 'success'
          });
        }

        /*
        if (
          addToPackage &&
          this.selectedCustomer &&
          eventData.productPackageId
        ) {
          this.invoiceService
            .savePackageToInvoice(
              eventData.invoiceId || undefined,
              eventData.productPackageId
            )
            .subscribe((res) => {
              if (!eventData.invoiceId) {
                eventData.invoiceId = res.id;

              }
            });
        }
        */
      } else {
        this.dynamicDialogRef.close({
          type: 'unauthorized'
        });
        this.messageService.clear();
        const msg = this.translateService.instant(
          'event.messages.event-cannot-be-saved'
        );
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: msg
        });
      }
    } catch (error: any) {
      this.formDisabled = true;
      // A rejected save (e.g. 1010, the staff member is not free at this
      // time) comes as an error code: showError translates it.
      this.utilsService.showError(error);
    }
  }

  doCancel(): void {
    this.dynamicDialogRef.close(null);
  }

  doDelete(): void {
    this.dynamicDialogRef.close({
      type: 'deleteEvent',
      eventId: this.eventData.id
    });
  }

  handleUser(user: any): void {
    if (!user) return;

    const payload = user.value ? user.value : user;
    const type = user.userType ? user.userType : payload && payload.userType;

    if (type === UserType.staff || type === 'staff') {
      this.selectedUser = payload && payload.id ? payload : null;
      this.eventForm.patchValue({ user: this.selectedUser });
    } else if (type === UserType.customer || type === 'customer') {
      this.selectedCustomer = payload && payload.id ? payload : null;
      this.eventForm.patchValue({ customer: this.selectedCustomer });
    } else if (type === UserType.donor || type === 'donor') {
      this.selectedDonor = payload && payload.id ? payload : null;
      this.eventForm.patchValue({ customer: this.selectedDonor });
    }
  }

  selectedEventTypeChange(eventType: Setting): void {
    this.eventData.eventType = eventType;
    if (eventType.code === 'todo') {
      this.eventData.eventDate = null;
      this.loadForm();
    }
    // this.loadForm();
  }

  setTime(formTime: Date): string {
    return (
      String(formTime.getHours()).padStart(2, '0') +
      ':' +
      String(formTime.getMinutes()).padStart(2, '0')
    );
  }

  async onSaveButtonClick(routeTo?: string): Promise<void> {
    if (routeTo === 'customer' && this.formDisabled && this.selectedCustomer) {
      if (this.selectedCustomer.customerType === 'd') {
        this.router.navigate(['donor/basic', this.selectedCustomer.id]);
      } else {
        this.router.navigate(['customer/basic', this.selectedCustomer.id]);
      }
      this.dynamicDialogRef.close({
        type: 'success'
      });
    } else if (
      routeTo === 'forms' &&
      this.formDisabled &&
      this.selectedCustomer
    ) {
      if (this.selectedCustomer.customerType === 'd') {
        this.router.navigate([
          'donor/basic',
          this.selectedCustomer.id,
          'organization-forms'
        ]);
      } else {
        this.router.navigate([
          'customer/basic',
          this.selectedCustomer.id,
          'organization-forms'
        ]);
      }
      this.dynamicDialogRef.close({
        type: 'success'
      });
    } else if (
      routeTo === 'healthrecord' &&
      this.formDisabled &&
      this.selectedCustomer
    ) {
      await this.customerService.setSelectedCustomer(this.selectedCustomer);
      if (this.selectedCustomer.customerType === 'd') {
        this.router.navigate(['donor/healthrecord/list']);
      } else {
        this.router.navigate(['customer/healthrecord/list']);
      }
      this.dynamicDialogRef.close({
        type: 'success'
      });
    } else {
      const formData = this.eventForm.getRawValue();
      this.saveEvent(formData, routeTo);
    }
  }

  handleSelectedUser(event: any, userType: UserType): void {
    let e = null;
    if (event && event.value) {
      e = event.value;
    } else if (event) {
      e = event;
    }
    if (userType === UserType.staff) {
      this.selectedUser = e && e.id ? e : null;
      this.eventForm.patchValue({ user: this.selectedUser });
    } else if (userType === UserType.customer) {
      this.selectedCustomer = e && e.id ? e : null;
      this.eventForm.patchValue({ customer: this.selectedCustomer });
      this.checkAppointmentForms(this.selectedCustomer?.id || '');
      if (
        this.selectedCustomer &&
        this.selectedCustomer.id &&
        (!this.selectedCustomer.relations ||
          this.selectedCustomer.relations.length === 0)
      ) {
        this.customerService
          .getCustomerRelations(this.selectedCustomer.id)
          .subscribe((result) => {
            this.selectedCustomer!.relations = result || [];
            this.customerService
              .getPartner(this.selectedCustomer)
              .then((partner) => {
                this.partner = partner;
              });
          });
      }
      /*
      if (this.eventData.customer.relations) {
                const p = this.eventData.customer.relations.find(
                  (r: CustomerRelation) =>
                    r.relation === 'partner' && r.status === 1
                );
                if (p) {
                  this.partner = p;
                }
              }
                */
    } else if (userType === UserType.donor) {
      this.selectedDonor = e && e.id ? e : null;
      this.eventForm.patchValue({ customer: this.selectedDonor });
    }

    this.disableSaveButton();
  }

  disableSaveButton(): void {
    const rawForm = this.eventForm.getRawValue();
    if (
      !rawForm.user &&
      !rawForm.room &&
      !(rawForm.userGroups && rawForm.userGroups.length)
    ) {
      this.saveDisabled = true;
    } else {
      this.saveDisabled = false;
    }
  }

  handleRadioGroup(key: string, value: any): void {
    this.eventData[key] = value;
    if (key === 'net') {
      if (value === 1 || value === true || value === '1') {
        this.net = true;
      } else {
        this.net = false;
      }
    }
  }

  handleSelectedDate(e: Date): void {
    this.selectedDate = e;
    this.eventData.eventDate = e;
    this.eventForm.patchValue({ eventDate: this.selectedDate });
  }

  /**
   * Käyntitodistus (AL-2893): the visit certificate as an A4 PDF in a new
   * tab. The language defaults to the organization unit's language; the
   * chevron menu offers fi/sv/en/pl. The fixed texts follow the chosen
   * language, stored data (names, the printing user's Kela speciality text
   * and SV number) prints as is and the staff member's specialities print
   * with their setting labels in the chosen language.
   */
  async printVisitCertificate(language?: string): Promise<void> {
    if (this.printing) {
      return;
    }
    this.printing = true;
    let previewWindow: Window | null = null;
    try {
      // Before any await: the tab opens within the click (popup blockers).
      previewWindow = this.visitCertificatePdfService.openPreviewWindow();
      const userProfile = this.authService.getUserProfile();
      const organizationUnit = await this.loadPrintOrganizationUnit();
      const printLanguage =
        language || this.resolveDefaultPrintLanguage(organizationUnit);
      // A failed load stops the printout with an error rather than printing
      // a certificate that silently lacks e.g. the SV number or the address.
      const [signer, staff, specialitySettings, uiSpecialitySettings] =
        await Promise.all([
          userProfile?.id
            ? firstValueFrom(this.userService.getUser(userProfile.id))
            : Promise.resolve(null),
          this.selectedUser?.id
            ? firstValueFrom(this.userService.getUser(this.selectedUser.id))
            : Promise.resolve(null),
          this.settingService.getSettingByName('SPECIALITIES', printLanguage),
          // Labels missing in the print language fall back to these.
          this.settingService
            .getSettingByName('SPECIALITIES')
            .catch(() => [] as Array<Setting>)
        ]);
      const customerName = this.printName(
        this.selectedCustomer || this.eventData?.appointmentCustomer
      );
      const specialityCodes = (
        staff as unknown as { speciality?: unknown } | null
      )?.speciality;
      const blob = await this.visitCertificatePdfService.buildCertificatePdf({
        language: printLanguage,
        customerName,
        visitDate: this.selectedDate,
        startTime: this.eventForm.get('start')?.value || null,
        endTime: this.eventForm.get('end')?.value || null,
        staffName: this.printName(this.selectedUser),
        specialityCodes: Array.isArray(specialityCodes)
          ? specialityCodes.map((code) => String(code))
          : [],
        specialitySettings: specialitySettings || [],
        fallbackSpecialitySettings: uiSpecialitySettings || [],
        signerName: this.printName(signer) || this.printName(userProfile),
        signerSignature: signer?.signature,
        signerRegistryNumber: signer?.registryNumber,
        organizationUnit
      });
      const shown = this.visitCertificatePdfService.showPreview(
        previewWindow,
        blob,
        this.visitCertificatePdfService.buildFileName(customerName)
      );
      if (!shown) {
        this.utilsService.showError(
          this.translateService.instant(
            'event.visit-certificate-print.popup-blocked'
          )
        );
      }
    } catch (error) {
      previewWindow?.close();
      console.error('Failed to generate the visit certificate PDF', error);
      this.utilsService.showError(
        this.translateService.instant('event.visit-certificate-print.error')
      );
    } finally {
      this.printing = false;
    }
  }

  /** Opens the printout language menu. The default language gets its check
   *  mark once the organization unit (its language) has loaded. */
  openPrintLanguageMenu(event: Event, popover: Popover): void {
    popover.toggle(event);
    this.loadPrintOrganizationUnit().catch(() => {
      this.defaultPrintLanguage = this.resolveDefaultPrintLanguage(null);
    });
  }

  /** The active organization unit with its language and contact info —
   *  the token carries neither. Loaded once per dialog; a failed load is not
   *  cached, so the next print retries it. */
  private loadPrintOrganizationUnit(): Promise<OrganizationUnit | null> {
    if (!this.printOrganizationUnit) {
      const unitId =
        this.authService.getUserProfile()?.activeOrganizationUnit?.id;
      const unit$: Promise<OrganizationUnit | null> = unitId
        ? firstValueFrom(this.organizationUnitService.getUnitById(unitId))
        : Promise.resolve(null);
      this.printOrganizationUnit = unit$.then(
        (unit) => {
          this.defaultPrintLanguage = this.resolveDefaultPrintLanguage(unit);
          return unit;
        },
        (error) => {
          this.printOrganizationUnit = null;
          throw error;
        }
      );
    }
    return this.printOrganizationUnit;
  }

  /** The organization unit's language; a unit without a supported language
   *  prints in the UI language, else in English (the app's fallback). */
  private resolveDefaultPrintLanguage(unit: OrganizationUnit | null): string {
    const unitLanguage = unit?.language;
    if (isPrintLanguage(unitLanguage)) {
      return unitLanguage;
    }
    const uiLanguage = this.translateService.getCurrentLang();
    return isPrintLanguage(uiLanguage) ? uiLanguage : 'en';
  }

  private printName(
    person:
      | { firstName?: string | null; lastName?: string | null }
      | null
      | undefined
  ): string {
    return [person?.firstName, person?.lastName]
      .map((part) => (part || '').trim())
      .filter((part) => part.length > 0)
      .join(' ');
  }

  onInlineCustomerSaved(customer: Customer): void {
    this.customerService.setSelectedCustomer(customer);
    this.selectedCustomer = customer;
    this.eventForm.patchValue({ customer: this.selectedCustomer });
    this.eventData.customerId = customer.id;
    this.showInlineScForm = false;
    this.inlineScCustomer = null;
    this.schedulerService
      .saveCustomerToEvent(this.eventData.id, customer.id)
      .subscribe(() => {});
  }

  private buildInlineScCustomer(): void {
    if (
      !this.eventData?.appointmentCode ||
      this.selectedCustomer ||
      this.eventData?.customerId
    )
      return;
    this.showInlineScForm = true;
    this.inlineScCustomer = {
      id: '',
      customerType: 'sc',
      personalId: this.eventData.appointmentCustomer?.personalId || '',
      firstName: this.eventData.appointmentCustomer?.firstName || '',
      lastName: this.eventData.appointmentCustomer?.lastName || '',
      personalIdType: 'permanent'
    } as Customer;
  }

  isDate(value: any): boolean {
    return value instanceof Date;
  }

  get isOpuPackageSelected(): boolean {
    const packageId = this.eventForm.get('productPackageId')?.value;
    if (!packageId || !this.eventPackages) return false;
    const pkg = this.eventPackages.find((p) => p.id === packageId);
    return pkg?.packageEventType === 'OPU';
  }

  onTriggerDurationChange(value: string | null): void {
    this.selectedTriggerDuration = value;
    this.recomputeTriggerTime();
  }

  private recomputeTriggerTime(): void {
    if (!this.isOpuPackageSelected || !this.selectedTriggerDuration) {
      this.triggerTimeBasedOnOpu = null;
      return;
    }
    const startValue = this.eventForm.get('start')?.value;
    if (!startValue || !this.selectedDate) {
      this.triggerTimeBasedOnOpu = null;
      return;
    }
    const parts = String(startValue).split(':');
    if (parts.length < 2) {
      this.triggerTimeBasedOnOpu = null;
      return;
    }
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    if (isNaN(hours) || isNaN(minutes)) {
      this.triggerTimeBasedOnOpu = null;
      return;
    }
    const startDate = new Date(this.selectedDate);
    startDate.setHours(hours, minutes, 0, 0);
    const durationHours = parseFloat(this.selectedTriggerDuration);
    if (isNaN(durationHours)) {
      this.triggerTimeBasedOnOpu = null;
      return;
    }
    this.triggerTimeBasedOnOpu = new Date(
      startDate.getTime() - durationHours * 60 * 60 * 1000
    );
  }
}
